module.exports = __webpack_public_path__ + "static/media/photo-3.5fa66765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/cambridge-student-accommodation/photo-3.jpg
// module id = 155
// module chunks = 0